import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import classnames from 'classnames';

import BreedTraitCard from './BreedTraitCard';
import JumpToScorecardButton from './JumpToScorecardButton';

export default function BreedAtAGlanceSection() {
  const { breedData } = useSelector(({ server }) => server);

  const columns = useMemo(() => {
    return Object.values(breedData.at_a_glance).reduce(
      (acc, curr, currentIndex) => {
        let index = 0;
        if (currentIndex > 1) {
          index = 1;
        }
        if (currentIndex > 4) {
          index = 2;
        }
        acc[index].push(curr);

        return acc;
      },
      [[], [], []]
    );
  }, [breedData.at_a_glance]);

  return (
    <div className="BreedAtAGlanceSection dn db-l pt6 ph20">
      <div className="flex justify-between items-center mb4 mb10-md">
        <h3 className="f6 f8-md lh-title">At a glance</h3>
        <JumpToScorecardButton iconPosition="right" />
      </div>
      <div className="row no-gutters br4 overflow-hidden">
        {columns.map((col, i, colArr) => (
          <div key={i} className="col-4">
            <div
              className={classnames('flex flex-column h-100', {
                pr1: i < colArr.length - 1
              })}
            >
              {col.map((desc, idx, traitsArr) => (
                <BreedTraitCard
                  key={idx}
                  className={idx < traitsArr.length - 1 ? 'mb1' : ''}
                  description={desc.description}
                  category={desc.category}
                  rating={desc.score}
                  icon={desc.icon_name}
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
